import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosError } from "axios";
import { CompanyBlockUnblockValidationSchema } from "../schemas/blockUnblockCompany.schema";

interface UseBlockCompanyProps {
  companyId?: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}

const useBlockClientCompany = ({ companyId, onSuccess, onError }: UseBlockCompanyProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation<void, AxiosError, CompanyBlockUnblockValidationSchema>({
    mutationKey: ['blockCompany', companyId],
    mutationFn: async (data) => {
      await privateAxios.put(`/client/companies/${companyId}/block`, {
        company: data,
      });
    },
    onSuccess,
    onError,
  });
};

export default useBlockClientCompany;
